<template>
    <div class="my_goods_car">
        <div class="box" v-if="isReload==false && cart_product.length!==0">
            <ul class="goods_operation_box" >
                <li>
                    <h3>我的购物车</h3>
                    <router-link tag="div" to="/">继续购物 <i class="iconfont icon-youkuohao" style="font-size:12px;">&#xe684;</i></router-link>
                </li>
                <li >
                    <ul class="goods_operation">
                        <li >
                            <span >
                                <el-checkbox  v-model="checkAll" @change="select_All(checkAll)" >全选</el-checkbox>
                            </span>
                            <span >商品名称</span>
                            <span >单价</span>
                            <span >折扣</span>
                            <span >数量</span>
                            <span >小计（元）</span>
                            <span >库存</span>
                            <span >操作</span>
                        </li>
                        <li v-for="(item,index) in cart_product" :key="index">
                            <span >
                                <el-checkbox class="margin-right-10" v-model="item.is_selected" @change="radio_select" :disabled="item.disabled = (item.disabled && item.store_qty<1)" ></el-checkbox>
                                <el-image
                                    class="mouse-pointer"
                                    fit="cover"
                                    style="width:110px;min-width:110px;height:110px;"
                                    :src="item.product_img_url"
                                    @click="goToDetail(item)"
                                >
                                    <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                                        <div class="el_image">
                                            <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:14px"></span>
                                        </div>
                                    </div>
                                    <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                                        <div class="el_image">
                                            <el-image  fit="cover" :src="src.src_err"  style="width:70px;height:70px;"></el-image>
                                        </div>
                                    </div>
                                </el-image>
                            </span>
                            <span class="mouse-pointer" @click="goToDetail(item)">{{item.product_name}}</span>
                            <span>
                                <p>{{item.unit_price}}</p>
                                <p>{{item.product_discount_price}}</p>
                            </span>
                            <span>{{item.discount==10?'暂无折扣':item.discount+'折'}}</span>
                            <span><el-input-number v-model="item.product_qty" :min="1" :max="item.store_qty" :disabled="item.store_qty<1"></el-input-number></span>
                            <span>{{(item.product_discount_price*item.product_qty).toFixed(2)}}</span>
                            <span>{{item.store_qty}}</span>
                            <span @click="remove_product(item.product_hash,index)">删除</span>
                        </li>
                    </ul>
                <li >
                    <div class="total_left">
                        <el-checkbox class="margin-right-10" v-model="checkAll" @change="select_All(checkAll)">全选</el-checkbox>
                        <span @click="many_select_remove">删除选中的商品</span>
                    </div>
                    <div class="total_right">
                        <p >已选择&nbsp;{{product_num}}&nbsp;件商品，合计（不含运费）：<span>￥<i >{{product_price}}</i></span></p>
                        <div @click="settlement">去结算</div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 数据加载 -->
        <div v-if="isReload"  style="width:1200px;height:600px;background:transparent;margin:0 auto;" class="el_image">
            <div v-loading="true"></div>
            <div style="color:#409eff;font-size:14px;margin:100px 0 0 -14px;">数据加载中</div>
        </div>
        <!-- 无数据 -->
        <div v-if="isReload==false && cart_product.length==0"  class="el_image el_images">
            <router-link tag="div" to="/" class="iconfont icon-gouwuche shopping"> 继续购物</router-link>
            <el-image
                fit="cover"
                style="width:600px;height:600px;"
                :src="src.src_null"
            >
                <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                    <div class="el_image">
                        <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:20px"></span>
                    </div>
                </div>
                <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                    <div class="el_image">
                        <el-image  fit="cover" :src="src.src_err"  style="width:100px;height:100px;"></el-image>
                    </div>
                </div>
            </el-image>
        </div>
    </div>
</template>
<script>
import src_err from '@/assets/img/err.png'
import src_null from '@/assets/img/null.png'

export default {
    name:'my_goods_car',
    data(){
        return {
            src:{
                src_err,
                src_null
            },
            // 是否全选
            checkAll: true,
            // 购物车商品数量
            product_num:0,
            // 购物车商品总价
            product_price:0,
            // 购物车商品
            cart_product:[],
            // 是否加载
            isReload:true
        }
    },
    watch:{
        cart_product:{
            handler:function(){
                let arr=this.cart_product
                let num=0
                let price=0
                for(let i in arr){
                    if(arr[i].is_selected==true && arr[i].disabled===false){
                        num+=arr[i].product_qty
                        price+=arr[i].product_discount_price*arr[i].product_qty
                    }
                }
                this.product_num=num
                this.product_price=price.toFixed(2)
            },
            deep:true
        }
    },
    methods: {
        // 跳转到商品详情页
        goToDetail(item){
            this.$router.push({path:'/product_detail',query:{product_hash:item.product_hash}})
        },
        // 点击全选
        select_All(o){
        let arr=this.cart_product
            for(let i=0;i<arr.length;i++){
                if(arr[i].disabled===false){
                    arr[i].is_selected=o
                }
            }
           this.cart_product=arr
        },
        // 点击单选
        radio_select(){
            let arr=this.cart_product
            let num=0
            for(let i in arr){
                if(arr[i].is_selected==true){
                    num++
                }
            }
            if(num==arr.length){
                this.checkAll=true
            }else{
                this.checkAll=false
            }
        },
        // 删除单个商品
        remove_product(h,i){
            this.$confirm('是否删除此商品?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: 'romove_product',
                    data: {
                        product_hash:h
                    }
                }).then((res)=>{
                    if(res.code==1){
                        this.$message({
                            message: '商品删除成功',
                            type: 'success'
                        });
                        this.cart_product.splice(i,1)
                        this.getGoodsCound()
                    }
                }).catch((err)=>{
                    console.log(err)
                })
            }).catch(() => {

            });
        },
        // 删除多个商品
        many_select_remove(){
            let arr=this.cart_product
            let str=''
            for(let i in arr){
                if(arr[i].is_selected==true){
                    str+=arr[i].product_hash+','
                }
            }
            if(str.length!==0){
                this.$confirm('确定删除全部商品?', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        url: 'romove_product',
                        data: {
                            product_hash:str
                        }
                    }).then((res)=>{
                        if(res.code==1){
                            this.$message({
                                message: '商品删除成功',
                                type: 'success'
                            });
                            if(this.checkAll==true){
                                this.cart_product=[]
                            }else{
                                for(let i=arr.length-1;i>=0;i--){
                                    if(arr[i].is_selected==true){
                                        arr.splice(i,1)
                                    }
                                }
                                this.cart_product=arr
                            }
                            this.getGoodsCound()
                        }
                    }).catch((err)=>{
                        console.log(err)
                    })
                }).catch(() => {

                });
            }else{
                this.$message({
                    message: '先选中商品，方可删除',
                    type: 'warning'
                });
            }
        },
        // 结算
        settlement(){
            let arr=this.cart_product
            let str=''
            let num=''
            for(let i in arr){
                if(arr[i].is_selected==true && arr[i].disabled===false){
                    str+=arr[i].product_hash+','
                    num+=arr[i].product_qty+','
                }
            }
            if(str.length==0){
                this.$message({
                    message: '请选择（有库存）商品，然后结算',
                    type: 'warning'
                });
            }else{
                this.$router.push({
                    path:'/settlement',
                    query:{
                        product_hash:str,
                        qty:num
                    }
                })
            }
        },
        // 获取页面数据的ajax
        getPageAjax(){
            this.$http({
                url: 'my_goods_car',
                data: {}
            }).then((res)=>{
                this.isReload=false
                if(res.code==1){
                    this.cart_product=res.data.cart_product
                }
            }).catch((err)=>{
                console.log(err)
            })
        },
        // 获取购物车商品数量
        getGoodsCound(){
            this.$http({
                url: 'goods_count',
                data: {}
            }).then((res)=>{
                if(res.code==1){
                    this.$store.commit({
                        type:'set_goodsCount',
                        num:res.data.cart_product_count
                    })
                }
            }).catch((err)=>{
                console.log(err)
            })
        }
    },
    created(){
        this.getPageAjax()
        this.getGoodsCound()
    }
}
</script>
<style lang="scss" scoped>
.margin-right-10{
    margin-right: 10px;
    cursor: pointer,
}
.mouse-pointer{
    cursor: pointer
}
.my_goods_car{
    background:#F7F7F5;
    box-sizing:border-box;
    padding-top:46px;
}
.box{
   width:1200px;
   margin:30px auto 0;
}
.goods_operation_box{
    >li{
        display:flex;
        align-items:center;
        background:white;
        // border:1px solid #CCCCCC ;
    }
    >li:first-child{
        justify-content: center;
        position:relative;
        font-size:24px;
        height:70px;
        >div{
            font-size:14px;
            color:#686868;
            position:absolute;
            right:20px;
            cursor: pointer;
        }
        >div:hover{
            color:#4285f4;
        }
    }
    >li:nth-child(2){
        margin:20px 0;
    }
    >li:last-child{
        display:flex;
        align-items: center;
        justify-content: space-between;
        padding:25px 20px;
        >div{
            display:flex;
            align-items: center;
        }
        .total_left{
            span{
                cursor: pointer;
            }
            span:hover{
                color:#F41200 ;
            }
        }
        .total_right{
            p{
                display:flex;
                align-items: center;
                span{
                    font-size: 40px;
                    color:#F41200 ;
                }
            }
            div{
                width:160px;
                height:50px;
                margin-left:20px;
                text-align: center;
                line-height:50px;
                border-radius:30px;
                font-size: 18px;
                color:white;
                background:#F41200 ;
                cursor: pointer;
            }
        }
    }
}
.goods_operation{
    width:100%;
    >li{
        display:flex;
        align-items: center;
        height:60px;
        border-bottom:2px solid #f7f7f5;
        >span{
            width:100px;
            display:block;
        }
        >span:nth-child(1){
            width:180px;
            padding-left:20px;
        }
        >span:nth-child(1)~span{
            text-align: center;
        }
        >span:nth-child(2){
            width:300px;
        }
        >span:nth-child(5){
            width:200px;
        }
    }
    >li:first-child~li{
        height:140px;
        >span:nth-child(1){
            display:flex;
            align-items: center;
        }
        >span:nth-child(3){
            p{
                line-height:30px;
            }
            p:first-child{
                text-decoration: line-through;
                color:#BABDBF ;
            }
        }
        >span:nth-child(6){
            color:#f51200;
        }
        >span:nth-child(8){
            cursor:pointer;
        }
        >span:nth-child(8):hover{
            color:#f51200;
        }
    }
    >li:last-child{
        border:none;
    }
}
.el_images{
    width:1200px;
    height:600px;
    background:transparent;
    margin:0 auto;
    position:relative;
}
.shopping{
    position:absolute;
    left:540PX;
    top:560PX;
    cursor:pointer;
    padding:5px 10px;
    border-radius:5px;
    font-size:14px;
    z-index:10;
    border:1px solid #409eff;
    animation:identifier 3s infinite;
}
.shopping:hover{
    animation-play-state:paused;
}
@keyframes identifier {
    0% {
        color:transparent;
        border:1px solid transparent;
    }
    50% {
        color:#409eff;
        border:1px solid #409eff;
    }
    100% {
        color:transparent;
        border:1px solid transparent;
    }
}
</style>
<style scoped>
.goods_operation_box >>> .el-checkbox__inner{
    width:20px;
    height:20px;
}
.goods_operation_box >>> .el-checkbox__inner::after{
    width:6px;
    height:14px;
    left:6px;
    top:0px;
}
.goods_operation_box >>> .el-checkbox__input{
    vertical-align: bottom;
}

</style>
